@if (loading()) {
  <aux-table-skeleton />
} @else {
  <aux-table-panel>
    <div class="flex items-center justify-between p-4">
      <div>
        <div class="grid grid-cols-[1fr_auto] gap-4">
          <div>
            <label for="vendor-select" class="mb-1 block font-medium">Vendor Contract</label>
            <ng-select
              [ngModel]="selectedVendor()"
              [disabled]="vendors().length === 0"
              [items]="vendors()"
              bindLabel="name"
              bindValue="id"
              class="select-with-custom-option w-[290px]"
              [clearable]="false"
              appendTo="body"
            >
              <ng-template let-item="item" ng-option-tmp>
                <div
                  #text
                  (click)="onVendorChangeAttempt($event, item.id)"
                  class="option-wrapper truncate"
                  [auxTooltip]="text.offsetWidth < text.scrollWidth ? item.name : ''"
                  auxTooltipPanelContainerClass="ag-not-extendable-attribute-dropdown-tooltip"
                >
                  {{ item.name }}
                </div>
              </ng-template>
            </ng-select>
          </div>
          <div>
            <div class="mb-1 block font-medium">&nbsp;</div>
            <div class="flex h-[35px]">
              <aux-checkbox [(ngModel)]="isApplyToAllVendors">
                <div class="text-sm">Apply to All Vendor Contracts (excluding PO #)</div>
              </aux-checkbox>
            </div>
          </div>
        </div>
      </div>

      <div class="self-end">
        <aux-button
          variant="tertiary"
          icon="Plus"
          label="Add New Attribute"
          class="mr-2 dark:text-aux-blue-light-4"
          [disabled]="addNewAttributeDisabled()"
          [auxTooltip]="addNewAttributeDisabled() ? 'Maximum number of attributes reached' : ''"
          (click)="onAddNewAttribute()"
        />
      </div>
    </div>

    <ag-grid-angular
      [gridOptions]="gridOptions()"
      (gridReady)="onGridReady($event)"
      (firstDataRendered)="onFirstDataRendered($event)"
      [domLayout]="'autoHeight'"
      class="new-flat-theme"
      [rowData]="rowData()"
    />
  </aux-table-panel>
}
